<script lang="ts">
  import { onMount } from 'svelte';
  import { getCountdown, type Countdown } from '../lib/storage';
  import { href } from '../lib/router';
  import CountdownDisplay from '../components/CountdownDisplay.svelte';

  type Props = { id: string };
  let { id }: Props = $props();

  let countdown: Countdown | undefined = $state(undefined);
  let loaded = $state(false);

  onMount(async () => {
    countdown = await getCountdown(id);
    loaded = true;
  });
</script>

{#if !loaded}
  <!-- silent; load usually under 50ms -->
{:else if !countdown}
  <main class="not-found">
    <h1>Countdown not found</h1>
    <p>It may have been deleted from this device.</p>
    <a href={href('/')}>Go back</a>
  </main>
{:else}
  <CountdownDisplay {countdown} />
{/if}

<style>
  .not-found {
    text-align: center;
    padding: 12vh 24px;
  }
  .not-found h1 {
    font-size: 1.5rem;
    margin: 0 0 0.5rem;
  }
  .not-found p {
    opacity: 0.6;
    margin: 0 0 1.5rem;
  }
  .not-found a {
    color: inherit;
    text-decoration: underline;
  }
</style>
